export default __webpack_public_path__ + "static/media/eco-car.733bb387.svg";